import React from 'react'

class MessageNavigation extends React.Component {
  componentDidMount() {
    const fallback = document.getElementById('message-nav-fallback');
    if (fallback) fallback.style.display = 'none';
  }

  render() {
    const { unseenCount, linkClass, path } = this.props

    return(
      <div>
        <div>
          <a className={`btn-block text-white ${linkClass}`} href={path}>
            Inbox {unseenCount > 0 && <span className='count-notification label ml4'>{unseenCount}</span>}
          </a>
        </div>
      </div>
    )
  }
}

export default MessageNavigation
